/**
 * Payment methods come from the admin panel with an explicit display order (`seqN`).
 * Both `MontonioPaymentMethod` and `CreditPaymentMethod` carry it
 */
export const getEnabledPaymentMethodsInDisplayOrder = <T extends { enabled: boolean; seqN: number }>(
  methods: T[]
): T[] => methods.filter(({ enabled }) => enabled).toSorted((a, b) => a.seqN - b.seqN)

// The payment service settles these without the provider: `CREDIT` charges the company account,
// `NONE` is the zero-amount method. Its prepare answer may then carry no redirect URL
const METHODS_SETTLED_WITHOUT_PROVIDER = new Set<string>(['CREDIT', 'NONE'])

/**
 * Whether a prepare answer without `redirectUrl` still means the payment is done.
 * Mirrors the payment service: only an immediate payment, the company credit and the zero-amount method skip
 * the payment provider. Every other method is paid at the provider, so a missing URL means nothing was paid.
 * `redirectToPaymentProvider` is not used: it is `false` for the Maksekeskus card methods too
 */
export const canCompleteWithoutPaymentRedirect = ({
  code,
  immediatePayment,
}: {
  code: string
  immediatePayment: boolean
}): boolean => immediatePayment || METHODS_SETTLED_WITHOUT_PROVIDER.has(code)
